
import { useI18n } from "vue-i18n";
import { mapGetters } from "vuex";
import { LoginGetters } from "@/modules/login/store/types";
export default {
  name: "Message",
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  props: {
    text: {
      type: String,
    },
  },
  computed: {
    ...mapGetters("loginModule", {
      failedLoginTimeout: LoginGetters.GET_ERROR_TIMEOUT,
    }),
  },
};
